import { getConfig } from '@superbet-group/web.lib.config';

import { transformShop } from '@core/mappers/country/transformShop';
import { ShopDto } from '@core/mappers/country/dtos/ShopDto';
import Country from '@models/country/Country';
import Shop from '@models/country/Shop';

import RestService from './_private/RestService';

export class CountryService {
    private restService: RestService = new RestService();

    /**
     * @throws {RequestError}
     * @throws {Error}
     */
    public async getShops(): Promise<Shop[]> {
        const response = await this.restService.getShops();
        const dtos = response.data.ClubList as ShopDto[];
        return dtos.map(transformShop).filter((shop) => shop.isActive);
    }

    public getCountries(): Promise<Country[]> {
        return this.restService.getCountries();
    }

    public async getPaymentProvidersLogos(): Promise<any> {
        const response = await this.restService.getPaymentProvidersLogos(getConfig().countrySpecific.country);
        return response.data;
    }
}

export default new CountryService();
